exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.footer_box[data-v-59d63ddb] {\n    height: 2.133333rem;\n}\n.footer_fixed[data-v-59d63ddb] {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 2.133333rem;\n    z-index: 100;\n    box-shadow:0px -2px 7px 0px rgba(245,245,245,1);\n}\n.footer[data-v-59d63ddb] {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    min-width: 8rem;\n    max-width: 16rem;\n    height: 2.133333rem;\n    margin: 0 auto;\n    background-color: #fff;\n}\n.footer_list[data-v-59d63ddb] {\n    flex: 1;\n    text-align: center;\n}\n.footer_img[data-v-59d63ddb] {\n    width: 0.896rem;\n}\n.footer_title[data-v-59d63ddb] {\n    color: #999;\n    font-size: 0.469333rem;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/views/encyclopedia/footerBox.vue?vue&type=style&index=0&id=59d63ddb&scoped=true&lang=css&
// module id = 252
// module chunks = 0 1